import getRouterBasename from '@/lib/router';
import App from 'App';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import {
  useApi,
  useAuth,
  useChatInteract,
  useConfig
} from '@chainlit/react-client';

export default function AppWrapper() {
  const [translationLoaded, setTranslationLoaded] = useState(false);
  const { isAuthenticated, isReady } = useAuth();
  const { language: languageInUse } = useConfig();
  const { i18n } = useTranslation();
  const { windowMessage } = useChatInteract();

  function handleChangeLanguage(languageBundle: any): void {
    i18n.addResourceBundle(languageInUse, 'translation', languageBundle);
    i18n.changeLanguage(languageInUse);
  }

  const { data: translations } = useApi<any>(
    `/project/translations?language=${languageInUse}`
  );

  useEffect(() => {
    if (!translations) return;
    handleChangeLanguage(translations.translation);
    setTranslationLoaded(true);
  }, [translations]);

  useEffect(() => {
    const handleWindowMessage = (event: MessageEvent) => {
      windowMessage(event.data);
    };
    window.addEventListener('message', handleWindowMessage);
    return () => window.removeEventListener('message', handleWindowMessage);
  }, [windowMessage]);

  if (!translationLoaded) return null;

  const base = getRouterBasename();
  const isShareRoute = window.location.pathname.startsWith(base + '/share/');

  if (
    isReady &&
    !isAuthenticated &&
    !isShareRoute &&
    window.location.pathname !== base + '/login' &&
    window.location.pathname !== base + '/login/callback'
  ) {
    // Preserve the user's original destination across the login round-trip
    // by passing it as `?redirect=...` on the login URL. Login.tsx picks it
    // up, stashes it in localStorage (survives Google's OAuth redirect
    // chain), and AuthCallback.tsx restores it via window.location.href.
    const dest = window.location.pathname + window.location.search;
    const skip = dest === '/' || dest === base + '/' || dest === base;
    const loginUrl =
      base +
      '/login' +
      (skip ? '' : `?redirect=${encodeURIComponent(dest)}`);
    window.location.href = loginUrl;
  }
  return <App />;
}
